// removed by extract-text-webpack-plugin
module.exports = {"Cell":"_2MI8V_lO4Gd4HeCfXySEJd","hovered":"_39BA52XfxX-2DMig_bcA1T"};


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/Cell/style.css
// module id = 348
// module chunks = 0